import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

interface Props {
  children: React.ReactNode;
}

export function AuthGuard({ children }: Props) {
  const { isLoading, isAuthenticated, tenantId } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="text-sm text-slate-500">読み込み中...</div>
      </div>
    );
  }

  if (!isAuthenticated || !tenantId) {
    return <Navigate to="/onboarding" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
